(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[396],{

/***/ 5399:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(2295);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 72px;\n  @media screen and (max-width: 1439px) and (min-width: 905px) {\n    height: 60px;\n  }\n  @media screen and (max-width: 904px) and (min-width: 600px) {\n    height: 52px;\n  }\n  @media screen and (max-width: 599px) {\n    height: 44px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var HeaderSpaceWrapper = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HeaderSpaceWrapperContainer, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (HeaderSpaceWrapper);
var HeaderSpaceWrapperContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "HeaderSpaceWrapper__HeaderSpaceWrapperContainer",
    componentId: "sc-132c2234-0"
})(_templateObject());


/***/ }),

/***/ 8722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useRemoveScrollTop; }
/* harmony export */ });
/* harmony import */ var context_BlogContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var useRemoveScrollTop = function() {
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().asPath;
    var dispatch = (0,context_BlogContext__WEBPACK_IMPORTED_MODULE_0__/* .useBlogContext */ .F)().dispatch;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!asPath.includes("blog")) {
            dispatch({
                type: "change",
                newState: {
                    prevScrollTop: 0
                }
            });
        }
    }, [
        asPath,
        dispatch
    ]);
};


/***/ }),

/***/ 2295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PrivacyPolicyPageContainer": function() { return /* binding */ PrivacyPolicyPageContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2322);
/* harmony import */ var components_NewHeader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(614);
/* harmony import */ var components_About_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5710);
/* harmony import */ var components_Common_HeaderSpaceWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2763);
/* harmony import */ var components_Footer_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2587);
/* harmony import */ var global_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9059);
/* harmony import */ var hooks_useRemoveScrollTop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8722);
/* harmony import */ var locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9014);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5505);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  overflow-x: hidden;\n\n  & > .inner-container {\n    text-align: center;\n    @media screen and (min-width: 1440px) {\n      width: 100%;\n      max-width: 1048px;\n      margin: 142px auto 202px;\n    }\n    @media screen and (min-width: 1240px) and (max-width: 1439px) {\n      width: calc(100% - 192px);\n      margin: 142px 96px 202px;\n    }\n    @media screen and (min-width: 905px) and (max-width: 1239px) {\n      width: calc(100% - 112px);\n      margin: 142px 56px 202px;\n    }\n    @media screen and (min-width: 600px) and (max-width: 904px) {\n      width: calc(100% - 64px);\n      margin: 142px 32px 202px;\n    }\n    @media screen and (max-width: 599px) {\n      width: calc(100% - 32px);\n      margin: 142px 16px 202px;\n    }\n  }\n  .top-area {\n    text-align: left;\n  }\n  .last-up {\n    color: ",
        ";\n    text-align: center;\n  }\n  .title {\n    text-align: center;\n    color: ",
        ";\n    margin-bottom: 8px;\n  }\n  .desc {\n    color: ",
        ";\n    margin: 96px 0;\n  }\n  .pol-box {\n    color: ",
        ";\n  }\n  .pol-box + .pol-box {\n    margin-top: 32px;\n  }\n  .pol-title {\n    color: ",
        ";\n  }\n  .pol-desc {\n    color: ",
        ";\n    white-space: pre-line;\n    margin-top: 8px;\n  }\n  .policy-area {\n    text-align: left;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var PrivacyPolicyPage = function() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)().locale;
    var articleArray = locale === "en" ? locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.en.articles : locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.ko.articles;
    (0,hooks_useRemoveScrollTop__WEBPACK_IMPORTED_MODULE_7__/* .useRemoveScrollTop */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PrivacyPolicyPageContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_9___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: "Privacy Policy - BLUEDOT"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: locale === "en" ? locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.en.midDesc : locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.ko.midDesc
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:description",
                        content: locale === "en" ? locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.en.midDesc : locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.ko.midDesc
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:description",
                        content: locale === "en" ? locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.en.midDesc : locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.ko.midDesc
                    }, "twitter:description")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_NewHeader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                isScrolled: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Common_HeaderSpaceWrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "inner-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "top-area",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_6__/* .H2KR */ .Zj, {
                                className: "title",
                                children: locale === "en" ? "BLUEDOT Privacy Policy" : "블루닷 개인정보처리방침"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_6__/* .SubtitleL */ .ar, {
                                className: "last-up",
                                children: locale === "en" ? "2022.09.07 last updated" : "2022.09.07 마지막으로 업데이트 됨"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_6__/* .BodyTextM */ .OV, {
                                className: "desc",
                                children: locale === "en" ? locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.en.midDesc : locale_privacyPolicy__WEBPACK_IMPORTED_MODULE_8__.ko.midDesc
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "policy-area",
                        children: articleArray.map(function(art) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "pol-box",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_6__/* .SubtitleM */ .sy, {
                                        className: "pol-title",
                                        children: art.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_styles__WEBPACK_IMPORTED_MODULE_6__/* .BodyTextS */ .Ei, {
                                        as: "pre",
                                        className: "pol-desc",
                                        style: {
                                            fontWeight: 400
                                        },
                                        children: art.desc
                                    })
                                ]
                            }, art.title);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_About_index__WEBPACK_IMPORTED_MODULE_3__/* .AboutCheckoutProduct */ .yz, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Footer_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PrivacyPolicyPage);
var PrivacyPolicyPageContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].section.withConfig */ .ZP.section.withConfig({
    displayName: "privacy-policy__PrivacyPolicyPageContainer",
    componentId: "sc-8081c3d6-0"
})(_templateObject(), global_styles__WEBPACK_IMPORTED_MODULE_6__/* .GRAY50 */ .mu, global_styles__WEBPACK_IMPORTED_MODULE_6__/* .BBINDIGO */ ._4, global_styles__WEBPACK_IMPORTED_MODULE_6__/* .GRAY30 */ .zm, global_styles__WEBPACK_IMPORTED_MODULE_6__/* .GRAY50 */ .mu, global_styles__WEBPACK_IMPORTED_MODULE_6__/* .GRAY30 */ .zm, global_styles__WEBPACK_IMPORTED_MODULE_6__/* .GRAY50 */ .mu);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [726,769,572,352,710,774,888,179], function() { return __webpack_exec__(5399); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);